<template>
	<div class="page">
		<div class="hero">
			<div class="hero-bg"></div>
			<i class="el-icon-search"></i>
			<h1>企业信息筛查系统</h1>
			<p class="subtitle">实名核验 · 反查匹配 · 多源清洗 · 高效提取关键信息</p>
			<div class="badges">
				<span class="badge">企业信息核验</span>
				<span class="badge">多渠道反查</span>
				<span class="badge">清洗去重</span>
				<span class="badge">精准画像</span>
			</div>
			<ul class="shapes">
				<li></li><li></li><li></li><li></li><li></li>
				<li></li><li></li><li></li><li></li><li></li>
				<li></li><li></li>
			</ul>
			<ul class="ribbons"><li></li><li></li><li></li></ul>
			<div class="actions">
				<el-button type="primary" @click="open('https://hy.shuhailinghang.cn/')">前往筛查系统</el-button>
				<el-button class="custom-button" @click="open('https://pp.shuhailinghang.cn/')">前往反查匹配系统</el-button>
			</div>
		</div>
		<div class="section">
			<h2>系统介绍</h2>
			<div class="cards">
				<div class="card intro-card">
					<p>数海领航信息筛查系统带来全新客户数据源，解决联系方式错误、多渠道联系难、找不到客户、客户不活跃、客户画像不匹配等问题；支持企业信息实名核验、筛查清洗与反查匹配，为需精准完整企业信息，提供高效准确的数据关键信息提取服务。</p>
				</div>
			</div>
		</div>
		<div class="bottom-section">
			<div class="card feature-grid">
				<div class="feature"><i class="el-icon-check"></i><span>实名核验</span></div>
				<div class="feature"><i class="el-icon-connection"></i><span>多渠道匹配</span></div>
				<div class="feature"><i class="el-icon-magic-stick"></i><span>清洗去重</span></div>
				<div class="feature"><i class="el-icon-user"></i><span>企业画像</span></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'EnterpriseScreening',
	methods: {
		open(url) {
			try {
				// 尝试使用 window.open
				const newWindow = window.open(url, '_blank');
				
				// 检查是否被阻止
				if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
					// 如果弹窗被阻止，尝试直接跳转
					window.location.href = url;
				}
			} catch (error) {
				console.error('跳转失败:', error);
				// 如果都失败了，尝试直接跳转
				window.location.href = url;
			}
		}
	}
}
</script>

<style scoped>
.page { padding: 24px 24px 48px; width: 100%; max-width: none; margin: 0 auto; background: linear-gradient(180deg, #f7fbff 0%, #f5f9ff 60%, #f2f6ff 100%); border-radius: 12px; min-height: calc(100vh - 48px); display: flex; flex-direction: column; }
.hero { position: relative; overflow: hidden; background: linear-gradient(135deg, #e6f7ff 0%, #f0f5ff 100%); padding: 40px 24px; border-radius: 12px; text-align: center; }
.hero-bg { position: absolute; inset: -20%; background: radial-gradient(circle at 20% 20%, rgba(255,255,255,0.8), transparent 40%), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.6), transparent 45%), radial-gradient(circle at 40% 80%, rgba(255,255,255,0.5), transparent 50%); filter: blur(8px); }
.hero i { position: relative; z-index: 1; font-size: 56px; color: #1890ff; animation: pop 2.6s ease-in-out infinite; }
.hero h1 { position: relative; z-index: 1; margin: 28px 0 28px; font-size: 36px; letter-spacing: 0.3px; background: none !important; -webkit-background-clip: initial !important; background-clip: initial !important; color: #0f2b46 !important; text-shadow: 0 1px 2px rgba(255,255,255,0.8); }
.subtitle { position: relative; z-index: 1; color: #143a5a; margin-bottom: 32px; font-size: 18px; font-weight: 700; line-height: 2.1; padding: 8px 12px; background: rgba(255,255,255,0.65); border-radius: 8px; display: inline-block; }
.badges { position: relative; z-index: 1; display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; margin: 20px 0 32px; }
.badge { background: rgba(24,144,255,0.14); color: #0f2b46; padding: 6px 12px; border-radius: 999px; font-size: 13px; font-weight: 700; text-shadow: 0 1px 1px rgba(255,255,255,0.6); }
.actions { position: relative; z-index: 1; margin-top: 28px; display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; }
.section { margin-top: 16px; }
.section h2 { margin: 0 0 32px; text-align: center; }
.cards { display: grid; grid-template-columns: 1fr; gap: 24px; }
.card { background: #ffffff; border: 1px solid #e6eef8; border-radius: 12px; }
.intro-card { padding: 24px 28px; color: #2f4059; line-height: 2.0; font-size: 16.5px; }
.intro-card p { max-width: 900px; margin: 0 auto; word-break: break-word; }
.feature-grid { padding: 16px; display: grid; grid-template-columns: repeat(4, minmax(160px, 1fr)); gap: 12px; }
.feature { background: #f8fbff; border: 1px solid #e6eef8; padding: 12px; border-radius: 10px; display: flex; align-items: center; gap: 8px; justify-content: center; color: #35506e; }
.bottom-section { margin-top: auto; padding-top: 32px; padding-bottom: 24px; }
.feature i { color: #1890ff; }
@keyframes floaty { 0% { transform: translateY(0) rotate(0); } 50% { transform: translateY(-6px) rotate(2deg);} 100% { transform: translateY(0) rotate(0);} }
@keyframes pop { 0%,100% { transform: scale(1);} 50% { transform: scale(1.06);} }
.shapes { position: absolute; inset: 0; margin: 0; padding: 0; list-style: none; pointer-events: none; }
.shapes li { position: absolute; left: 0; top: -20%; width: 28px; height: 28px; background: rgba(24,144,255,0.28); border-radius: 6px; animation: fallDown 12s linear infinite; }
.shapes li:nth-child(1){ left: 5%; width: 36px; height: 36px; animation-duration: 14s; animation-delay: .2s; }
.shapes li:nth-child(2){ left: 20%; width: 48px; height: 48px; animation-duration: 16s; animation-delay: .6s; }
.shapes li:nth-child(3){ left: 35%; width: 30px; height: 30px; animation-duration: 12s; animation-delay: .1s; }
.shapes li:nth-child(4){ left: 55%; width: 42px; height: 42px; animation-duration: 18s; animation-delay: .4s; }
.shapes li:nth-child(5){ left: 70%; width: 28px; height: 28px; animation-duration: 13s; animation-delay: .3s; }
.shapes li:nth-child(6){ left: 85%; width: 60px; height: 60px; animation-duration: 17s; animation-delay: .5s; }
.shapes li:nth-child(7){ left: 12%; width: 26px; height: 26px; animation-duration: 11s; animation-delay: .7s; }
.shapes li:nth-child(8){ left: 42%; width: 40px; height: 40px; animation-duration: 15s; animation-delay: .9s; }
.shapes li:nth-child(9){ left: 62%; width: 34px; height: 34px; animation-duration: 13s; animation-delay: .3s; }
.shapes li:nth-child(10){ left: 78%; width: 46px; height: 46px; animation-duration: 16s; animation-delay: .8s; }
.shapes li:nth-child(11){ left: 28%; width: 24px; height: 24px; animation-duration: 12s; animation-delay: .4s; }
.shapes li:nth-child(12){ left: 48%; width: 52px; height: 52px; animation-duration: 18s; animation-delay: .6s; }
@keyframes fallDown { 0% { transform: translateY(-20vh) rotate(0deg); opacity: .9; } 100% { transform: translateY(120vh) rotate(360deg); opacity: .6; } }

.feature { transition: transform .25s ease, box-shadow .25s ease; }
.feature:hover { transform: translateY(-3px); box-shadow: 0 10px 18px rgba(24,144,255,0.12); }
.feature i { font-size: 18px; margin-right: 6px; }
/* Animated gradient shift for hero */
.hero { background-size: 240% 240%; animation: gradientShift 10s ease infinite; }
.hero h1 { background: linear-gradient(90deg, #0f62fe, #52a8ff, #0f62fe); -webkit-background-clip: text; background-clip: text; color: transparent; background-size: 200% 100%; animation: titleShimmer 6s linear infinite; }
@keyframes titleShimmer { 0% { background-position: 0% 50%; } 100% { background-position: 200% 50%; } }
.hero::before { content: ""; position: absolute; inset: 0; background: radial-gradient(600px 300px at 15% 10%, rgba(255,255,255,0.35), transparent 60%), radial-gradient(500px 260px at 85% 20%, rgba(255,255,255,0.25), transparent 60%); pointer-events: none; }
@keyframes gradientShift { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }

/* Stronger shapes motion and variation */
.shapes li { filter: blur(0.2px); opacity: 0.85; }
.shapes li:nth-child(1){ width: 18px; height: 18px; animation-duration: 5s; animation-delay: .2s; }
.shapes li:nth-child(2){ width: 22px; height: 22px; animation-duration: 6.5s; animation-delay: .6s; }
.shapes li:nth-child(3){ width: 14px; height: 14px; animation-duration: 4.8s; animation-delay: .1s; }
.shapes li:nth-child(4){ width: 28px; height: 28px; animation-duration: 7s; animation-delay: .4s; }
.shapes li:nth-child(5){ width: 16px; height: 16px; animation-duration: 5.6s; animation-delay: .3s; }
.shapes li:nth-child(6){ left: 28%; top: 35%; width: 20px; height: 20px; animation-duration: 6.2s; }
.shapes li:nth-child(7){ left: 62%; top: 40%; width: 18px; height: 18px; animation-duration: 5.6s; }
.shapes li:nth-child(8){ left: 40%; top: 75%; width: 22px; height: 22px; animation-duration: 6.8s; }
.shapes li:nth-child(9){ left: 12%; top: 50%; width: 16px; height: 16px; animation-duration: 5.2s; }
.shapes li:nth-child(10){ left: 88%; top: 56%; width: 24px; height: 24px; animation-duration: 7.2s; }
.shapes li:nth-child(11){ left: 50%; top: 88%; width: 14px; height: 14px; animation-duration: 5.0s; }
.shapes li:nth-child(12){ left: 48%; top: 18%; width: 26px; height: 26px; animation-duration: 6.6s; }

/* Badge glow pulse */
.badge { box-shadow: 0 0 0 rgba(24,144,255,0.0); animation: glowPulse 3.2s ease-in-out infinite; }
@keyframes glowPulse { 0%,100% { box-shadow: 0 0 0 rgba(24,144,255,0); } 50% { box-shadow: 0 8px 18px rgba(24,144,255,0.22); } }

/* Buttons subtle pulse */
.actions .el-button { transition: transform .25s ease, box-shadow .25s ease; }
.actions .el-button:hover { transform: translateY(-2px) scale(1.02); box-shadow: 0 10px 22px rgba(24,144,255,0.18); }

/* Custom button styling */
.actions .custom-button {
	background: white;
	border-color: #1890ff;
	color: #1890ff;
}
.actions .custom-button:hover {
	background: #f0f8ff;
	border-color: #40a9ff;
	color: #40a9ff;
	box-shadow: 0 10px 22px rgba(24,144,255,0.18);
}

/* Feature cards entrance */
.feature { animation: cardIn .5s ease both, floaty 6.5s ease-in-out .6s infinite; }
.feature:nth-child(1){ animation-delay: .05s; }
.feature:nth-child(2){ animation-delay: .12s; }
.feature:nth-child(3){ animation-delay: .19s; }
.feature:nth-child(4){ animation-delay: .26s; }
@keyframes cardIn { from { opacity: 0; transform: translateY(8px);} to { opacity: 1; transform: translateY(0);} }

/* Button breathing */
.actions .el-button { animation: breathe 3.6s ease-in-out .2s infinite; }
@keyframes breathe { 0%,100% { transform: translateY(0) scale(1); } 50% { transform: translateY(-1px) scale(1.03); } }
/* Big flowing ribbons */
.ribbons { position: absolute; inset: 0; margin: 0; padding: 0; list-style: none; pointer-events: none; z-index: 0; }
.ribbons li { position: absolute; left: -10%; right: -10%; height: 140px; filter: blur(18px); opacity: 0.55; background: linear-gradient(90deg, rgba(24,144,255,0.0), rgba(24,144,255,0.45), rgba(24,144,255,0.0)); animation: sweep 9s ease-in-out infinite; }
.ribbons li:nth-child(1){ top: 10%; }
.ribbons li:nth-child(2){ top: 45%; animation-delay: 1.2s; height: 160px; opacity: 0.6; }
.ribbons li:nth-child(3){ top: 78%; animation-delay: 2.4s; height: 130px; opacity: 0.5; }
@keyframes sweep { 0% { transform: translateX(-10%) rotate(0.5deg);} 50% { transform: translateX(10%) rotate(-0.5deg);} 100% { transform: translateX(-10%) rotate(0.5deg);} }
</style> 